// extracted by mini-css-extract-plugin
export default {"userRoleManagement":"fJHs5aiaEtpoFxmUC6lf","labelContent":"iZfzDq4RCvsUZ5m2rsvV"};